import * as core from '../../../../../../../core'
import * as summit from '../summit'

export const RESOURCE = {
  payload: {
    alias: 'outcomes',
    appAlias: summit.RESOURCE.payload.alias,
    description: "Manage and monitor your organization's strategic goals",
    display: {
      isMain: false,
      position: 2,
    },
    name: 'Outcomes (Table)',
    page: { alias: 'summit:outcomes-table' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
